import React, { useRef } from "react";
import "./FilterActivity.css";

const SCROLL_STEP = 240;

const ActivityFilter = ({ options = [], selectedActivityKey = "", onSelect, isLoading = false }) => {
  const displayOptions = Array.isArray(options) ? options : [];
  const scrollRef = useRef(null);

  const scrollByAmount = (direction) => {
    if (!scrollRef.current) {
      return;
    }

    scrollRef.current.scrollBy({
      left: direction * SCROLL_STEP,
      behavior: "smooth",
    });
  };

  const handleWheel = (event) => {
    if (!scrollRef.current) {
      return;
    }

    const { deltaY, deltaX } = event;
    const scrollDelta = Math.abs(deltaX) > Math.abs(deltaY) ? deltaX : deltaY;

    if (scrollDelta === 0) {
      return;
    }

    event.preventDefault();
    scrollRef.current.scrollLeft += scrollDelta;
  };

  return (
    <section className="activityFilter">
      <h3 className="activityFilter__title">Filter Activity</h3>

      <div className="activityFilter__controls">
        <button
          type="button"
          className="activityFilter__nav"
          onClick={() => scrollByAmount(-1)}
          aria-label="Scroll filters left"
        >
          <i className="bi bi-chevron-left"></i>
        </button>

        <div
          ref={scrollRef}
          className="activityFilter__scrollArea"
          onWheel={handleWheel}
        >
          <div className="activityFilter__list">
            {isLoading
              ? Array.from({ length: 4 }).map((_, index) => (
                  <span
                    key={index}
                    className="dashboard-skeleton dashboard-skeleton--button activityFilter__skeleton"
                    aria-hidden="true"
                  />
                ))
              : displayOptions.map((activity) => {
                  const isSelected = selectedActivityKey === activity.key;

                  return (
                    <button
                      key={activity.key || activity.name}
                      type="button"
                      className={`activityFilter__option ${isSelected ? "activityFilter__option--active" : ""}`}
                      onClick={() => onSelect?.(activity)}
                    >
                      <span className="activityFilter__radio">
                        {isSelected && <span className="activityFilter__radioInner" />}
                      </span>

                      <span className="activityFilter__label">{activity.name}</span>
                    </button>
                  );
                })}
          </div>
        </div>

        <button
          type="button"
          className="activityFilter__nav"
          onClick={() => scrollByAmount(1)}
          aria-label="Scroll filters right"
        >
          <i className="bi bi-chevron-right"></i>
        </button>
      </div>
    </section>
  );
};

export default ActivityFilter;
